import useGetSharedVehicleLookup from '/business/shared/components/questions/_util_hooks/useGetSharedVehicleLookup';

export default function useGetTaxiSchema({
  dealershipName: applicationDealershipName,
}: {
  dealershipName?: string | null;
}) {
  return useGetSharedVehicleLookup({
    inputLabel: 'Estimated distance travelled by taxi for all employees',
    applicationDealershipName,
  });
}
